<div class="header">
    <div class="header-left">
        <a href="dashboard.html" class="logo">
            <img src="assets/img/pcsadthidilogo.png" alt="Logo" />
        </a>
        <a href="index.html" class="logo logo-small">
            <img src="assets/img/pcsadthidi.png" alt="Logo" width="30" height="30" />
        </a>
    </div>

    <!-- <a href="javascript:void(0);" id="toggle_btn">
        <i class="fe fe-text-align-left"></i>
    </a> -->
    <!-- <div class="top-nav-search">
        <form>
            <input type="text" class="form-control" placeholder="Search here" />
            <button class="btn" type="submit">
                <i class="fa fa-search"></i>
            </button>
        </form>
    </div> -->

    <!-- <a class="mobile_btn" id="mobile_btn">
        <i class="fa fa-bars"></i>
    </a> -->
    

    
</div>